/** @format */

import { digitalContentUrl } from "../Config/Url";
import axios from "axios";

export const digitalContentService = {
  getAll,
  create,
  update,
  remove,
};

async function getAll() {
  return axios
    .put(`${digitalContentUrl}/search`, { pageIndex: 0, pageSize: 100 })
    .then((res) => res)
    .catch((err) => err.response);
}

async function create(data) {
  return axios
    .post(`${digitalContentUrl}`, data)
    .then((res) => res)
    .catch((err) => err.response);
}

async function update(id, data) {
  return axios
    .put(`${digitalContentUrl}/${id}`, data)
    .then((res) => res)
    .catch((err) => err.response);
}

async function remove(id) {
  return axios
    .delete(`${digitalContentUrl}/${id}`)
    .then((res) => res)
    .catch((err) => err.response);
}
